import login from './login';

const users = {
  login,
};

export default users;
